import { render, staticRenderFns } from "./OnboardingContactComponent.vue?vue&type=template&id=6dbf5dde&"
import script from "./OnboardingContactComponent.vue?vue&type=script&lang=js&"
export * from "./OnboardingContactComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports